module.exports = __webpack_public_path__ + "img/res-bg@2x.c0a6056a.png";